import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { ReportState } from '@interfaces/reports/reports.state';
import { Report, ReportEntity, ReportFilters } from '@interfaces/reports/reports';
import { ReportsReadResponse } from '@interfaces/reports/reports.read.resp';
import { ReportingPagination } from '@interfaces/reports/reporting-generate.response';

export const initialValue: ReportState = {
  reports: [],
  currentFilterId: '',
  reportFilters: {
    reports: [],
    codeTypes: [],
    departments: [],
    locations: [],
    alarmTypes: [],
    nurseCallTypes: [],
    users: [],
  },
  filter: {
    departments: 'NONE',
    locations: 'NONE',
    alarms: 'NONE',
    codes: 'NONE',
    nurseCalls: 'NONE',
    status: 'NONE',
    startDate: '2025-06-01',
    endDate: '2025-06-30',
    users: 'NONE',
  },
  reportPagination: {
    page: 1,
    pageSize: 50,
    totalItems: 0,
    totalPages: 0,
  },
  reportSortOrder: 'DESC',
};

export const ReportStore = signalStore(
  { providedIn: 'root' },
  withState(initialValue),

  withMethods(({ ...store }) => ({
    setReports(reports: Array<ReportEntity>) {
      patchState(store, { reports });
    },
    setReportFilters(reportFilters: ReportsReadResponse) {
      patchState(store, { reportFilters });
    },
    updateReport(data: any) {
      const currentFilters = store.reportFilters();

      const updatedReports = currentFilters.reports.map((report) =>
        report.id === data.id ? data : report,
      );

      const updatedFilters = {
        ...currentFilters,
        reports: updatedReports,
      };

      patchState(store, { reportFilters: updatedFilters });
    },
    deleteReportFilter(filterId: String) {
      let currentFilters = store.reportFilters();

      let newFilters = store
        .reportFilters()
        .reports.filter((el) => el.id !== filterId);

      const updatedFilters = {
        ...currentFilters,
        reports: newFilters,
      };

      patchState(store, { reportFilters: updatedFilters });
    },
    addReportFilter(filter: Report) {
      let currentFilters = store.reportFilters();

      let newReports = JSON.parse(
        JSON.stringify(store.reportFilters().reports),
      );
      newReports.push(filter);

      const updatedFilters = {
        ...currentFilters,
        reports: newReports,
      };

      patchState(store, { reportFilters: updatedFilters });
    },
    setFilters(filter: ReportFilters) {
      patchState(store, { filter });
    },
    setCurrentFilterId(currentFilterId: string) {
      patchState(store, { currentFilterId });
    },
    setReportPagination(reportPagination: ReportingPagination) {
      patchState(store, { reportPagination });
    },
    setReportSortOrder(reportSortOrder: ReportState['reportSortOrder']) {
      patchState(store, { reportSortOrder });
    },
    clearReportResults() {
      patchState(store, {
        reports: [],
        reportPagination: initialValue.reportPagination,
        reportSortOrder: initialValue.reportSortOrder,
      });
    },

    clearAll() {
      patchState(store, {
        reports: [],
        reportFilters: initialValue.reportFilters,
        filter: initialValue.filter,
        currentFilterId: '',
        reportPagination: initialValue.reportPagination,
        reportSortOrder: initialValue.reportSortOrder,
      });
    },
  })),
);
